import styled from "styled-components";

export const HeaderContainer = styled.div`
    display: flex;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-right: 1.5rem;
    padding-left: 1.5rem;
    grid-area: content;
    width: 100%;
    align-items: center;
    z-index: 10;
`;

export const HeaderSection = styled.div`
    /* padding: 0.25rem; */
    width: 100%;
    height: 100%;
    display: flex;
`;

export const ReturnIcon = styled.img`
    color: #acb2c3;
    font-size: 28px;
    /* position: fixed; */
    top: 15px;
    left: 18px;
    cursor: pointer;
    z-index: 10;
    margin-top: 5px;
`;

export const HeaderLogo = styled(HeaderSection)`
    justify-content: center;
`;

export const PepperLogo = styled.img`
    max-width: 150px;
    margin-top: 5px;
`;

export const HeaderIcons = styled(HeaderSection)`
    justify-content: flex-end;
`;

export const CloseIcon = styled.img`
    color: #736967;
    font-size: 26px;
    margin-top: 5px;
    cursor: pointer;
    width: 13px;
`;